import { render, staticRenderFns } from "./RelatedMoods.vue?vue&type=template&id=65847a54&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./RelatedMoods.vue?vue&type=script&lang=js&"
export * from "./RelatedMoods.vue?vue&type=script&lang=js&"
import style0 from "./RelatedMoods.vue?vue&type=style&index=0&id=65847a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65847a54",
  null
  
)

export default component.exports